import React, { useState } from 'react';
import '../Category.scss';
import cardImg from '../../../assets/image/homepageback.png';
import './Courses.scss'
import '../../payment-section/Payment.scss'
import { Link } from 'react-router-dom';
import Payment from '../../payment-section/Payment';
import { makeStyles } from '@material-ui/core/styles';
export const PayContex = React.createContext();
const Courses = () => {
    const [pay, setPay] = useState(false);
    const categories = [
        {
            title: ' Huquiqiy bilimni oshirish',
            img: cardImg
        },
        {
            title: ' Huquiqiy bilimni oshirish',
            img: cardImg
        },
        {
            title: ' Huquiqiy bilimni oshirish, Huquiqiy bilimni oshirish',
            img: cardImg
        }
    ];



    return (
        <div>

            <div className="subcategory container"><span className="disabled">Ketegories</span> <i className="material-icons disabled">keyboard_arrow_right</i> Kurslar</div>
            <div className="categories-sec container">
                <div className="bg-text">Kurslar</div>
                <h3> Kurslar</h3>
                <div className="categories">
                    {
                        categories.map(category => {
                            return (<Link to='/categories/courses' className="card" >
                                <div className="img-box">
                                    <img src={category.img} className="card-img-top" /> </div>
                                <div className="card-body d-flex flex-column justify-contnet-center align-items-center">
                                    <div className="card-title">{category.title}</div>
                                    <Link to="/categories/courses/payment" className="btn btn-primary button btn-pay" onClick={() => {
                                        setPay(true);
                                    }} >Sotib Olish</Link>
                                </div>
                            </Link>

                            )
                        })

                    }
                </div>
            </div>
        </div>
    );
}

export default Courses;
